import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { userActions, userFeature } from 'rio-core';
import { of, switchMap } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import { promptsActions } from './prompts.actions';
import { PromptsService } from './prompts.service';

@Injectable()
export class PromptsEffects {
  private store = inject(Store);
  private actions$ = inject(Actions);
  private promptsService = inject(PromptsService);
  private router = inject(Router);

  loadPrompts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(promptsActions.loadPrompts),
      concatLatestFrom(() => this.store.select(userFeature.selectCurrentOrganizationId)),
      switchMap(([, organizationId]) =>
        this.promptsService.getPrompts(organizationId).pipe(
          map(prompts => promptsActions.loadPromptsSuccess({ prompts })),
          catchError(() => of(promptsActions.loadPromptsFailure())),
        ),
      ),
    ),
  );

  loadFilteredPrompts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(promptsActions.loadFilteredPrompts, promptsActions.loadFilteredPromptsWithEmptyFilters),
      concatLatestFrom(() => this.store.select(userFeature.selectCurrentOrganizationId)),
      switchMap(([{ filters }, organizationId]) =>
        this.promptsService.getPrompts(organizationId, filters).pipe(
          map(prompts => promptsActions.loadFilteredPromptsSuccess({ prompts })),
          catchError(() => of(promptsActions.loadFilteredPromptsFailure())),
        ),
      ),
    ),
  );

  selectOrganization$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.selectOrganization),
      map(() => this.router.url),
      filter(url => url === '/' || url.includes('/admin-panel/prompts')),
      map(() =>
        promptsActions.loadFilteredPromptsWithEmptyFilters({
          filters: undefined,
        }),
      ),
    ),
  );

  selectOrganizationInCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(userActions.selectOrganization),
      map(() => this.router.url),
      filter(url => url === '/' || url.includes('/admin-panel/categories')),
      map(() => promptsActions.loadPrompts()),
    ),
  );
}
